<template>
  <div class="inspectionIncoming">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="inspectionIncoming.pkid > 0 ? '来料检验编辑':'来料检验新建'"
        class="customer-edit"
        width="1400px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          style="position: relative"
          :model="inspectionIncoming"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="基本信息" name="first">
            <el-row>
              <el-col :span="8">
                <el-form-item label="凭证号：">
                  <el-input v-model="inspectionIncoming.voucherNo" placeholder="请输入" @change="getVoucher"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="检验员：">
                  <el-input v-model="inspectionIncoming.inspectorName" disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="检验时间：">
                  <el-input v-model="inspectionIncoming.createdTime" disabled/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="送货单号：">
                  <el-input v-model="inspectionIncoming.deliveryNo"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="送货日期：">
                  <el-date-picker
                      v-model="inspectionIncoming.deliveryDate"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="date"
                      placeholder="选择日期"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="供应商：">
                  <el-input v-model="inspectionIncoming.supplierName" placeholder="请选择" readonly>
                    <el-button slot="append" icon="el-icon-search" @click="$refs.selectSupplierManage.open()"/>
                  </el-input>
                  <supplier-manage-select ref="selectSupplierManage" @select="onSelectSupplier"/>
                </el-form-item>
              </el-col>
            </el-row>
            <div style="padding: 0 0 10px 10px;width: 90%;margin: 0 auto">
              <div slot="toolbar">
                <el-button type="primary" style="margin-bottom: 10px" @click="$refs.selectMaterial.open()">
                  新建
                </el-button>
              </div>
              <el-table
                  height="39vh"
                  :data="inspectionIncoming.inspectionReportVOS">
                <el-table-column prop="materialNo" width="90" align="center" label="物料编号"/>
                <el-table-column prop="materialName" width="210" align="center" label="物料名称"/>
                <el-table-column prop="purchaseOrderNo" width="130" align="center" label="采购单号"/>
                <el-table-column prop="purchaseOrderRowNo" width="130" align="center" label="行号"/>
                <el-table-column prop="factoryNo" width="130" align="center" label="pc号">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.factoryNo"/>
                  </template>
                </el-table-column>
                <el-table-column prop="submissionNum" align="center" label="送检数量">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.submissionNum" :disabled="inspectionIncoming.checkStatus>0" min="1" type="number"/>
                  </template>
                </el-table-column>
                <el-table-column prop="spotCheckNum" align="center" label="抽检数量">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.spotCheckNum" :disabled="inspectionIncoming.checkStatus>0" min="1" type="number"/>
                  </template>
                </el-table-column>
                <el-table-column prop="unqualifiedNum" align="center" label="抽检不合格数量">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.unqualifiedNum" :disabled="inspectionIncoming.checkStatus>0" min="1" type="number"/>
                  </template>
                </el-table-column>
                <el-table-column prop="badQuality" align="center" label="不良数量">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.badQuality" :disabled="inspectionIncoming.checkStatus>0" min="0" type="number"/>
                  </template>
                </el-table-column>
                <el-table-column prop="inspectionResult" align="center" width="160" label="检查结果">
                  <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.inspectionResult"
                        :disabled="inspectionIncoming.checkStatus>0"
                        style="display: block"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="ok"
                        inactive-text="ng"
                        @change="changeInspectionResult(scope.row)"/>
                  </template>
                </el-table-column>
                <el-table-column prop="note" width="200px" align="center" label="备注">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.note" type="textarea"/>
                  </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    class-name="vm-table_operate"
                    width="140px">
                  <template slot-scope="scope">
                    <el-button v-if="!scope.row.inspectionResult" type="primary" @click="editDetail(scope.row,scope.$index)">编辑</el-button>
                    <el-button v-else type="primary" @click="editDetail1(scope.row,scope.$index)">编辑</el-button>
                    <el-button v-if="inspectionIncoming.checkStatus<1" type="danger" @click="oneDelete(scope.$index,scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <material-select ref="selectMaterial" @select="getDetails"/>
              <inspection-incoming-detail-edit ref="editIncomingDetail" @save-success="getIncomingDetail"/>
              <inspection-incoming-detail-edit1 ref="editIncomingDetail1" @save-success1="getIncomingDetail1"/>
            </div>
          </el-tab-pane>
          <el-tab-pane v-if="inspectionIncoming.pkid > 0" label="工作流详情" name="third">
            <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <span slot="footer">
        <el-button type="info" @click="dialogVisible=false">关闭</el-button>
        <el-button :loading="submitLoading" type="primary" @click="save()">保存</el-button>
        <el-button
            :disabled="inspectionIncoming.status === 10"
            :loading="submitLoading"
            type="primary"
            @click="submit()">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import constants from "../../../util/constants";
  import SupplierManageSelect from "@/views/information/SupplierManage/SupplierManageSelect";
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import MaterialSelect from "@/views/information/SupplierManage/MaterialSelect";
  import InspectionIncomingDetailEdit from "@/views/purchase/inspectionIncoming/InspectionIncomingDetailEdit";
  import InspectionIncomingDetailEdit1 from "@/views/purchase/inspectionIncoming/InspectionIncomingDetailEdit1";

  export default {
    name: "InspectionIncomingEdit",
    components: {
      InspectionIncomingDetailEdit1,
      InspectionIncomingDetailEdit, MaterialSelect, SupplierManageSelect, HandleDetail},
    data() {
      return {
        constant,
        constants,
        editAuth: this.$auth(832),
        uploadLoading: false,
        billId: "0",
        billType: "23",
        handleType: constant.toSelect(constant.handleType),
        exportLoading: false,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        saveLoading: false,
        activeName: "first",
        value: "",
        inspectionIncoming: {
          pkid: 0,
          billNo: "",
          voucherNo: "",
          factoryNo: "",
          purchaseOrderNo: "",
          deliveryNo: "",
          deliveryDate: "",
          supplierId: "",
          customerId: "",
          customerName: "",
          status: 0,
          supplierName: "",
          inspectorName: "",
          inspectionReportVOS: [],
        },
        ruleValidate: {
          regionalManager: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.inspectionIncoming.pkid = id;
        this.billId = id + "";
        this.dialogVisible = true;
        if (this.inspectionIncoming.pkid > 0) {
          this.getData();
        }
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `inspectionInComings/${this.inspectionIncoming.pkid}`)
          .then(resp => {
            console.log(resp);
            this.inspectionIncoming = resp;
            this.contentLoading = false;
          });
      },
      getVoucher() {
        this.$http
          .get("basic", `sapPostingVouchers/voucherNo/${this.inspectionIncoming.voucherNo}`)
          .then(resp => {
            console.log(resp);
            this.inspectionIncoming.purchaseOrderNo = resp[0].purchaseOrderNo;
            this.inspectionIncoming.supplierName = resp[0].supplierName;
            this.inspectionIncoming.supplierId = resp[0].supplierId;
            this.inspectionIncoming.deliveryDate = resp[0].deliveryDate;
            this.inspectionIncoming.inspectionReportVOS = [];
            for (let item of resp) {
              this.inspectionIncoming.inspectionReportVOS.push({
                pkid: 0,
                masterId: 0,
                rowIndex: this.inspectionIncoming.inspectionReportVOS.length+1,
                materialId: item.materialId,
                materialName: item.materialName,
                materialNo: item.materialNo,
                submissionNum: item.submissionNum,
                factoryNo: item.factoryNo,
                inspectionTemplateDetailVOS: item.inspectionTemplateDetailVOS,
                rawMaterialInspections: item.rawMaterialInspections,
                inspectionDetailVOS: ["A:包装","B:标识","C:外观","D:规格型号"],
                spotCheckNum: 1,
                unqualifiedNum: 0,
                badQuality: 0,
                inspectionResult: true,
                note: "",
                inspectionType: 10,
                storageInspectionType: 30,
                conclusion: 0,
                needHandle: true,
                handleType: 10,
                handleDepartment: "",
                standards: "",
                practical: "",
                problemClassification: "",
                preliminaryInvestigation: "",
                responsibleDepartment: "",
                responsibleID: "",
                responsibleName: "",
                supplierID: "",
                supplierName: "",
                regionalID: "",
                regionalManager: "",
                handleID: "",
                handleName: "",
                qualitativeClassification: "",
                createdTime: "",
                inspectorName: "",
                accessoryList: [],
              });
            }

          });
      },
      changeInspectionResult(row) {
        console.log(row.inspectionResult);
        if (!row.inspectionResult) {
          this.$refs.editIncomingDetail.open(row);
        }
      },
      editDetail(row,index) {
        console.log(row.inspectionResult);
        this.$refs.editIncomingDetail.open(row,index);
      },
      editDetail1(row,index) {
        console.log(row.inspectionResult);
        this.$refs.editIncomingDetail1.open(row,index,this.inspectionIncoming);
      },
      onSelectSupplier(row) {
        this.inspectionIncoming.supplierId = row.pkid;
        this.inspectionIncoming.supplierName = row.name;
      },
      onSelectCustomer(row) {
        this.inspectionIncoming.customerId = row.pkid;
        this.inspectionIncoming.customerName = row.name;
      },
      reportSave_save() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.saveLoading = true;
            this.$http
              .post("basic", "inspectionReports/reportSave_save", this.inspectionIncoming)
              .then(() => {
                this.saveLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.saveLoading = false;
              });
          }
        });
      },
      reportSave_edit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.saveLoading = true;
            this.$http
              .post("basic", "inspectionReports/reportSave_edit", this.inspectionIncoming)
              .then(() => {
                this.saveLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.saveLoading = false;
              });
          }
        });
      },
      reportSubmit_save() {
        this.submitLoading = true;
        this.$http
          .post("basic", "inspectionReports/reportSubmit_save", this.inspectionIncoming)
          .then(() => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("操作成功");
          });
      },
      reportSubmit_edit() {
        this.submitLoading = true;
        this.$http
          .post("basic", "inspectionReports/reportSubmit_edit", this.inspectionIncoming)
          .then(() => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("操作成功");
          });
      },


      insert_submit(isSubmit) {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.saveLoading = true;
            this.$http
              .post("basic", `inspectionInComings/insert_submit/${isSubmit}`, this.inspectionIncoming)
              .then(() => {
                this.saveLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.saveLoading = false;
              });
          }
        });
      },
      update_submit(isSubmit) {
        console.log(this.inspectionShipment);
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", `inspectionInComings/update_submit/${isSubmit}`, this.inspectionIncoming)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("操作成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      //保存
      save() {
        if (this.inspectionIncoming.pkid>0) {
          this.update_submit(false);
        }else {
          this.insert_submit(false);
        }
      },

      //提交
      submit() {
        if (this.inspectionIncoming.pkid>0) {
          this.update_submit(true);
        }else {
          this.insert_submit(true);
        }
      },
      getDetails(row) {
        this.inspectionIncoming.inspectionReportVOS.push({
          pkid: 0,
          masterId: 0,
          rowIndex: this.inspectionIncoming.inspectionReportVOS.length+1,
          materialId: row.id,
          materialName: row.name,
          materialNo: row.no,
          submissionNum: 1,
          spotCheckNum: 1,
          unqualifiedNum: 0,
          badQuality: 0,
          inspectionResult: true,
          note: "",
          inspectionType: 10,
          storageInspectionType: 30,
          conclusion: 0,
          needHandle: true,
          handleType: 10,
          handleDepartment: "",
          standards: "",
          practical: "",
          problemClassification: "",
          preliminaryInvestigation: "",
          responsibleDepartment: "",
          responsibleID: "",
          responsibleName: "",
          supplierID: "",
          supplierName: "",
          regionalID: "",
          regionalManager: "",
          handleID: "",
          handleName: "",
          qualitativeClassification: "",
          createdTime: "",
          inspectorName: "",
          accessoryList: [],
          inspectionDetailVOS: ["A:包装","B:标识","C:外观","D:规格型号"],
        });
      },
      getIncomingDetail(row,index) {
        // console.log(row);
        this.inspectionIncoming.inspectionReportVOS[index] = row;
      },
      getIncomingDetail1(row,index) {
        console.log(row);
        this.inspectionIncoming.inspectionReportVOS[index] = row;
      },
      //详情表删除
      oneDelete(index) {
        this.inspectionIncoming.inspectionReportVOS.splice(index,1);
        //使tableData重新排序
        this.inspectionIncoming.inspectionReportVOS.forEach((item,index) => {
          item.rowIndex = index+1;
        });
      },
      onPictureList(index,row) {
        console.log(index,row);
      },
    },
  };
</script>

<style lang="scss">
  .inspectionIncoming {
    .table {
      width: 100%;
      margin: 2% auto;
      border-top: 1px solid #dddddd;
      border-left: 1px solid #dddddd;

      .tableLabel {
        width: 130px;
        padding: 1%;
        background: #f4f7fa;
        border-bottom: 1px solid #dddddd;
      }

      .tableModel {
        width: 20%;
        padding: 1%;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
      }
    }
  }

</style>
